export default __webpack_public_path__ + "static/media/george_s.ab27002b.jpg";